<template>
    <Breadcrumbs main="Items" mains="Items" title="Aspirateurs de site" />
    <div class="container-fluid">
        <div class="row">
            <CrawlerItemList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const CrawlerItemList = defineAsyncComponent(
    () => import('@/components/theme/crawler/CrawlerItemList.vue'),
);
</script>
